var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogOutCu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sign out"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5489",
    d: "M17 5.86364V4C17 2.89543 16.1046 2 15 2H4C2.89543 2 2 2.89543 2 4V18C2 19.1046 2.89543 20 4 20H15C16.1046 20 17 19.1046 17 18V16.1364",
    stroke: "#EE5294",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 1100",
    d: "M13 11L25 11",
    stroke: "#EE5294",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5475",
    d: "M22 15.5L26.3232 11.1768C26.4209 11.0791 26.4209 10.9209 26.3232 10.8232L22 6.5",
    stroke: "#EE5294",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogOutCu);
export default __webpack_public_path__ + "static/media/icon-log-out-cu.5b0399b1b664f8e4058464dfbeb25632.svg";
export { ForwardRef as ReactComponent };